import { ResponsiveProp, mapResponsiveProp } from "./responsiveProp";
export var alignToFlexAlign = function alignToFlexAlign(align) {
  return mapResponsiveProp(align, {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
    stretch: 'stretch'
  });
};
export var alignYToFlexAlign = function alignYToFlexAlign(alignY) {
  return mapResponsiveProp(alignY, {
    top: 'flex-start',
    center: 'center',
    bottom: 'flex-end',
    baseline: 'baseline'
  });
};